// extracted by mini-css-extract-plugin
module.exports = {"icon":"social-icons-module--icon--fqD0K","iconsContainer":"social-icons-module--icons-container--3nOqr"};